export const rewriteName = (name: string | undefined) => {
  if (!name) return '';
  const regex = /\b(SS |MS |RS |OS )\b/g;

  return name.replace(regex, '');
};
